import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, Text, Link } from '@hub-la/design-system';
import { Analytics, AnalyticsEvent } from '@hub-la/fe-core-analytics';
import { useRoleplay } from '@hub-la/fe-roleplay';
import EditOutlined from '@mui/icons-material/EditOutlined';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getSiteUrl, getAppUrl, routes } from '../../utils/routes.js';
import { useContainer } from '../hooks/use-container.js';
import { textEllipsis } from '../usecases/text-ellipsis.js';
import { UserAvatar } from './user-avatar.js';

const DropdownHeader = props => {
  const {
    isRoleplay
  } = useRoleplay();
  const {
    t
  } = useTranslation();
  const container = useContainer();
  const analytics = container.get(Analytics);
  const events = AnalyticsEvent.MAIN_MENU;
  const handleOnClick = (route, event, close) => {
    analytics.track(event);
    if (route.startsWith(window.location.origin)) {
      props.push(route.replace(window.location.origin, ''));
    } else {
      window.location.href = route;
    }
    close();
  };
  return jsxs(Stack, Object.assign({
    direction: "row",
    padding: 3,
    alignItems: "center",
    justifyContent: "space-between"
  }, {
    children: [jsxs(Stack, Object.assign({
      direction: "row",
      spacing: 3,
      alignItems: "center",
      justifyContent: "space-between"
    }, {
      children: [jsx(UserAvatar, {
        src: props.picture,
        variant: "square",
        width: "40px",
        height: "40px"
      }), jsxs(Stack, Object.assign({
        direction: "column"
      }, {
        children: [jsx(Text, Object.assign({
          variant: "body1",
          fontWeight: 500,
          color: "onSurface"
        }, {
          children: textEllipsis(props.firstName, 15)
        })), jsx(Link, Object.assign({
          variant: "body2",
          fontWeight: 700,
          style: {
            cursor: 'pointer'
          },
          onClick: () => handleOnClick(getSiteUrl(`/${props.username}`), events.PROFILE_CLICKED, props.close)
        }, {
          children: t('dropdown.header.showProfile')
        }))]
      }))]
    })), !isRoleplay && jsx(Stack, {
      children: jsx(IconButton, Object.assign({
        onClick: () => handleOnClick(getAppUrl(routes.SETTINGS), events.EDIT_PROFILE_CLICKED, props.close)
      }, {
        children: jsx(EditOutlined, {})
      }))
    })]
  }));
};

export { DropdownHeader };
